/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type ConfigurationAppsFragment = { __typename: 'ConfigurationApps', id: string, name: string, iconUrl?: string | null, appVersions?: Array<string> | null, isBootableValue: boolean };

export type ConfigApps_ConfigFragment = { __typename: 'ConfigurationModel', id: string, configApps?: { __typename: 'ConfigAppsGrouped', assignedApps: Array<{ __typename: 'ConfigurationApps', id: string, name: string, iconUrl?: string | null, appVersions?: Array<string> | null, isBootableValue: boolean }>, unassignedApps: Array<{ __typename: 'ConfigurationApps', id: string, name: string, iconUrl?: string | null, appVersions?: Array<string> | null, isBootableValue: boolean }> } | null };

export type ConfigUpdateContentSourceAppsMutationVariables = Types.Exact<{
  input: Types.ConfigurationUpdateContentSourceAppsInput;
}>;


export type ConfigUpdateContentSourceAppsMutation = { __typename: 'Mutation', configurationUpdateContentSourceApps: { __typename: 'ConfigurationModel', id: string } };

export const ConfigurationAppsFragmentDoc = gql`
    fragment ConfigurationApps on ConfigurationApps {
  id
  name
  iconUrl
  appVersions
  isBootableValue
}
    `;
export const ConfigApps_ConfigFragmentDoc = gql`
    fragment ConfigApps_config on ConfigurationModel {
  id
  configApps {
    assignedApps {
      ...ConfigurationApps
    }
    unassignedApps {
      ...ConfigurationApps
    }
  }
}
    ${ConfigurationAppsFragmentDoc}`;
export const ConfigUpdateContentSourceAppsDocument = gql`
    mutation ConfigUpdateContentSourceApps($input: ConfigurationUpdateContentSourceAppsInput!) {
  configurationUpdateContentSourceApps(input: $input) {
    id
  }
}
    `;
export type ConfigUpdateContentSourceAppsMutationFn = ApolloReactCommon.MutationFunction<ConfigUpdateContentSourceAppsMutation, ConfigUpdateContentSourceAppsMutationVariables>;

/**
 * __useConfigUpdateContentSourceAppsMutation__
 *
 * To run a mutation, you first call `useConfigUpdateContentSourceAppsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigUpdateContentSourceAppsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configUpdateContentSourceAppsMutation, { data, loading, error }] = useConfigUpdateContentSourceAppsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfigUpdateContentSourceAppsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConfigUpdateContentSourceAppsMutation, ConfigUpdateContentSourceAppsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConfigUpdateContentSourceAppsMutation, ConfigUpdateContentSourceAppsMutationVariables>(ConfigUpdateContentSourceAppsDocument, options);
      }
export type ConfigUpdateContentSourceAppsMutationHookResult = ReturnType<typeof useConfigUpdateContentSourceAppsMutation>;
export type ConfigUpdateContentSourceAppsMutationResult = ApolloReactCommon.MutationResult<ConfigUpdateContentSourceAppsMutation>;
export type ConfigUpdateContentSourceAppsMutationOptions = ApolloReactCommon.BaseMutationOptions<ConfigUpdateContentSourceAppsMutation, ConfigUpdateContentSourceAppsMutationVariables>;